/**
 * Represents the minicart panel component.
 */
const minicart = {};

// Imports
var processInclude = require('base/util');

// Constants
const CONFIG = {
    ID: {
        PANEL: 'hom-panel-minicart'
    },
    SELECTOR: {
        APP_SEARCH: '.hom-js-app-search',
        CHECKOUT_BUTTON: '.hom-js-checkout-begin',
        CHECKOUT_END: '.hom-js-checkout-end',
        BARCODE_ICON: '.hom-js-icon-barcode',
        MINICART_ICON: '.hom-icon-cart',
        MINICART_ICON_COUNT: '.mini-cart-count',
        PANEL_CONTAINER: '.state-cart-container',
        REMOVE_PRODUCT: '.hom-js-remove-line-item',
        SUB_TOTAL: '.sub-total',
        UUID_PREFIX: '.uuid-',
        WISHLIST_TAB: '.hom-js-wishlist-tab'
    },
    ATTR: {
        DATA: {
            ACTION: 'action',
            NAME: 'name',
            PID: 'pid',
            PLI: 'product-line-item',
            UUID: 'uuid'
        },
        ARIA: {
            LABEL: 'aria-label'
        },
        TITLE: 'title'
    },
    EVENT: {
        EMPTY_BASKET: 'hom:minicart:empty',
        UPDATE_MINICART_ICON_COUNT: 'count:update',
        UPDATE_SUB_TOTAL: 'hom:subTotal:update'
    },
    CLASS: {
        DISABLED: 'disabled',
        OPENED_PANEL: 'hom-panel__opened'
    }
};

/**
 * Verify if all arguments have a valid value.
 * @param {any} arguments - 1 or more arguments to validate
 * @returns {boolean} true if all arguments are valid
 */
function isValid() {
    var argument;

    for (var i = 0; i < arguments.length; i++) {
        argument = arguments[i];

        if (argument === undefined && argument === null && argument === 'undefined' && argument === 'null') {
            return false;
        }
    }

    return true;
}

/**
 * Checks whether the basket is valid. if invalid disables
 * checkout button
 * @param {Object} basketModel - AJAX response from the server
 */
function validateBasket(basketModel) {
    const $checkoutBtn = $(`${CONFIG.SELECTOR.CHECKOUT_BUTTON}`);

    if (basketModel.valid.error) {
        $checkoutBtn.addClass(CONFIG.CLASS.DISABLED);
    } else {
        $checkoutBtn.removeClass(CONFIG.CLASS.DISABLED);
    }
}

/**
 * re-renders the order sub total and the number of items in the cart
 * @param {Object} basketModel - AJAX response from the server
 */
function updateMiniCartTotals(basketModel) {
    const $subTotal = $(`${CONFIG.SELECTOR.SUB_TOTAL}`);

    $subTotal.empty().append(basketModel.totals.subTotal);
}

/**
 * Collection of all server AJAX calls related functions.
 */
const server = {
    /**
     * Append the minicart HTML to the minicart panel
     * @param {string} action - AJAX call action URL
     * @param {JQuery<HTMLElement>} $container - container of the HTML to append
     */
    minicartShow: function (action, $container) {
        // 1. Validate parameters
        if (!isValid(action, $container)) {
            return;
        }

        // 2. Start loading spinner
        $.spinner().start();

        // 3. Append the HTML to the minicart panel
        $.ajax({
            url: action,
            method: 'GET',
            success: function (html) {
                $container.html(html);
            },
            complete: function () {
                // 4. Stop loading spinner
                $.spinner().stop();
            }
        });
    },

    /**
     * Append the minicart HTML to the minicart panel
     * @param {string} action - AJAX call action URL
     * @param {JQuery<HTMLElement>} $element - element to replace with the HTML
     */
    updateHTML: function (action, $element) {
        // 1. Validate parameters
        if (!isValid(action, $element)) {
            return;
        }

        // 3. Replace the minicart icon HTML
        $.ajax({
            url: action,
            method: 'GET',
            success: function (html) {
                $element.replaceWith(html);
            }
        });
    }
};

/**
 * Collection of click event listeners.
 */
const setClickEvents = {
    onRemoveProduct: function () {
        $('body').on('click', CONFIG.SELECTOR.REMOVE_PRODUCT, function () {
            // Constants
            const $this = $(this);

            const action = $this.data(CONFIG.ATTR.DATA.ACTION);
            const name = $this.data(CONFIG.ATTR.DATA.NAME);
            const pid = $this.data(CONFIG.ATTR.DATA.PID);
            const uuid = $this.data(CONFIG.ATTR.DATA.UUID);

            const $pli = $this.closest(`${CONFIG.SELECTOR.UUID_PREFIX}${uuid}`);

            // Clear panel content html
            if (action && name && pid && uuid) {
                $.spinner().start();
                $.ajax({
                    url: action,
                    type: 'post',
                    dataType: 'json',
                    data: { pid: pid },
                    success: function (response) {
                        if (!response.error) {
                            if (response.isEmpty && response.emptyHTML) {
                                // 1. Show empty minicart HTML if basket is empty
                                $('body').trigger(CONFIG.EVENT.EMPTY_BASKET, response);
                            } else {
                                // 2. Remove minicart product line item
                                $pli.remove();
                            }

                            // 3. Show add to cart to all products that are rendered in the page and share the same ID
                            $('body').trigger('hom:quantitySelector:removeAll', { pid: pid });

                            // 4. Trigger the listener to update the subtotal and to to update the item quantity in the cart icon
                            if (response.basket) {
                                $('body').trigger(CONFIG.EVENT.UPDATE_SUB_TOTAL, response.basket);
                                $('body').trigger(CONFIG.EVENT.UPDATE_MINICART_ICON_COUNT, response.basket);
                            }
                        }
                    },
                    error: function (error) {
                        console.error(error);
                    },
                    complete: function (response) {
                        $.spinner().stop();
                        $.alert().error(response.responseJSON.message);
                    }
                });
            }
        });
    },

    /**
     * Call the react native SearchNested view
     */
    onSearch: function () {
        $('body').on('click', CONFIG.SELECTOR.APP_SEARCH, function () {
            // Constants
            const DATA = {
                action: 'openSearchScreen',
                targetScreen: 'SearchNested'
            };

            if (window.ReactNativeWebView) {
                try {
                    window.ReactNativeWebView.postMessage(JSON.stringify(DATA));
                } catch (error) {
                    console.error(error);
                }
            }
        });
    },

    /**
     * Call the react native SearchNested view after checkout
     */
    onCheckoutEnd: function () {
        $('body').on('click', CONFIG.SELECTOR.CHECKOUT_END, function () {
            // Constants
            const DATA = {
                action: 'openSearchScreenAfterCheckout',
                targetScreen: 'SearchNested'
            };

            if (window.ReactNativeWebView) {
                try {
                    window.ReactNativeWebView.postMessage(JSON.stringify(DATA));
                } catch (error) {
                    console.error(error);
                }
            }
        });
    },

    /**
     * Call the react native barcode reader view
     */
    onOpenBarcode: function () {
        $('body').on('click', CONFIG.SELECTOR.BARCODE_ICON, function (e) {
            e.preventDefault();

            // Constants
            const DATA = {
                action: 'openSearchScreen',
                targetScreen: 'codeReader'
            };

            try {
                window.ReactNativeWebView.postMessage(JSON.stringify(DATA));
            } catch (error) {
                console.error(error);
            }
        });
    },

    /**
     * Call the react native in app wishlist tab
     */
    onWishlist: function () {
        $('body').on('click', CONFIG.SELECTOR.WISHLIST_TAB, function () {
            // Constants
            const DATA = {
                action: 'openScreen',
                targetScreen: 'Favorites'
            };

            if (window.ReactNativeWebView) {
                try {
                    window.ReactNativeWebView.postMessage(JSON.stringify(DATA));
                } catch (error) {
                    console.error(error);
                }
            }
        });
    }
};

/**
 * Collection of minicart related custom events.
 */
const setCustomEvents = {
    /**
     * Set a minicart open panel custom event listener .
     */
    onPanelOpen: function () {
        const panel = $.panel(CONFIG.ID.PANEL);

        panel.onOpen(function () {
            // Constants
            const $panel = $(`#${CONFIG.ID.PANEL}`);
            const $container = $panel.find(CONFIG.SELECTOR.PANEL_CONTAINER);

            // Variables
            let action;

            if ($panel.length && $container.length) {
                action = $panel.data(CONFIG.ATTR.DATA.ACTION);

                if (action) {
                    server.minicartShow(action, $container);
                }
            }
        });
    },

    /**
     * Set a minicart close panel custom event listener .
     */
    onPanelClose: function () {
        const panel = $.panel(CONFIG.ID.PANEL);

        panel.onClose(function () {
            // Constants
            const $panel = $(`#${CONFIG.ID.PANEL}`);
            const $container = $panel.find(CONFIG.SELECTOR.PANEL_CONTAINER);

            // Clear panel content html
            if ($panel.length && $container.length) {
                $container.html('');
            }
        });
    },

    /**
     * Set a minicart update sub total custom event listener .
     */
    onQuantityChange: function () {
        $('body').on(CONFIG.EVENT.UPDATE_SUB_TOTAL, function (e, data) {
            updateMiniCartTotals(data);
            validateBasket(data);
        });

        $('body').on(CONFIG.EVENT.UPDATE_MINICART_ICON_COUNT, function (e, data) {
            // Constants
            const $element = $(`${CONFIG.SELECTOR.MINICART_ICON_COUNT}`);
            const label = CONFIG.ATTR.ARIA.LABEL;
            const title = CONFIG.ATTR.TITLE;

            if (
                data &&
                data.numItems &&
                data.resources.minicartCountOfItems &&
                $.isNumeric(data.numItems) &&
                data.numItems > 0
            ) {
                $element.text(data.numItems);
                $element.attr({
                    [label]: data.resources.minicartCountOfItems,
                    [title]: data.resources.minicartCountOfItems
                });
            } else {
                $element.empty();
                $element.removeAttr([label, title].join(' '));
            }
        });
    },

    /**
     * Set a minicart update sub total custom event listener .
     */
    setEmptyBasketHTML: function () {
        $('body').on(CONFIG.EVENT.EMPTY_BASKET, function (e, data) {
            if ('isEmpty' in data && 'emptyHTML' in data && data.isEmpty) {
                const $panel = $(`#${CONFIG.ID.PANEL}`);
                const $container = $panel.find(CONFIG.SELECTOR.PANEL_CONTAINER);
                const isPanelOpened = $panel.hasClass(CONFIG.CLASS.OPENED_PANEL);

                if ($panel.length && $container.length && isPanelOpened) {
                    $container.html(data.emptyHTML);
                }
            }
        });
    }
};

/**
 * Collection of minicart related visibility events.
 */
const setVisibilityEvents = {
    /**
     * Set the minicart number of items on page visibility shown.
     */
    onPageVisible: function () {
        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState !== 'hidden') {
                const $element = $(CONFIG.SELECTOR.MINICART_ICON);
                const action = $element.data('action');

                if ($element.length && isValid(action)) {
                    server.updateHTML(action, $element);
                }
            }
        });
    }
};

/**
 * Exposed event listener functions
 */
minicart.setEvents = function () {
    processInclude(setClickEvents);
    processInclude(setCustomEvents);
    processInclude(setVisibilityEvents);
};

module.exports = minicart;
